// Dsitributor Modal
var $modalToggle = kimal.$topBar.find('.open-distributor-modal');
var $modal       = kimal.$distributorModal;
var $modalBox    = $('.modal__wrapper');
var $closeModal  = $('#distributor-modal-close');

var activateModal = function() {
  $modal.addClass('distributor-modal--active');
  kimal.$body.addClass('modal-is-active');
};

var deactivateModal = function() {
  $modal.removeClass('distributor-modal--active');
  kimal.$body.removeClass('modal-is-active');
};

$modalToggle.on('click', function(e) {
  e.preventDefault();

  activateModal();
});

$modal.on('click', function(e) {
  if ($(e.target).hasClass('distributor-modal--active')) {
    deactivateModal();
  }
});

$closeModal.on('click', function() {
  deactivateModal();
})


